export default {"src":"/_next/static/media/404product.5a96825b.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};